import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Layout from './layout';
import LegendPanel from './panels/LegendPanel';
import SearchPanel from './panels/SearchPanel';
import ImageryPanel from './panels/ImageryPanel';
import ToolsPanel from './panels/ToolsPanel';
import DetailsByPinPanel from './panels/DetailsByPinPanel';
import DetailsByTmsPanel from './panels/DetailsByTmsPanel';
import DisclaimerPage from './layout/DisclaimerPage';
import { BASE_URL } from './constants';



let router = createBrowserRouter([
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '',
    element: <Layout />,
    children: [
      { path: '', index: true, element: <LegendPanel /> },
      { path: '/legend', element: <LegendPanel /> },
      { path: '/imagery', element: <ImageryPanel /> },
      { path: '/search', element: <SearchPanel /> },
      { path: '/details/:pin', element: <DetailsByPinPanel /> },
      { path: '/pin/:pin', element: <DetailsByPinPanel /> },
      { path: '/tms/:tms', element: <DetailsByTmsPanel /> },
      { path: '/tools', element: <ToolsPanel /> },
      { path: '/map', element: <div /> },
    ]
  }
], { basename: BASE_URL || '' })


const App: React.FC = () => {
  return <RouterProvider router={router} />
}


export default App;